import * as actions from '../actions'

var defaultState = null;

export default function users(state = defaultState, action) {
    switch (action.type) {

        case actions.USER_GET:
            var newState = state;
            if (!action.error) {
                newState = action.payload.data;
            }
            return newState;

        case actions.USER_CLEAN:
            return defaultState;

        default:
            return state;

    }
}
